import { extractLocalizedString } from './i18nLogic';
export function getSeoRestaurant(restaurant, displayableMenu, baseUrl, menuUrl) {
    var _a, _b;
    var seoAddress = {
        '@type': 'PostalAddress',
        addressCountry: restaurant.address.countryCode,
        addressLocality: restaurant.address.city,
        postalCode: restaurant.address.postalCode,
        streetAddress: restaurant.address.formatted,
    };
    var geo = {
        '@type': 'GeoCoordinates',
        latitude: restaurant.address.latLng.lat,
        longitude: restaurant.address.latLng.lng,
    };
    return {
        '@id': restaurant.id,
        '@type': 'Restaurant',
        Address: [seoAddress],
        geo: geo,
        hasMenu: getSeoMenu(restaurant, displayableMenu),
        image: ((_a = restaurant.media) === null || _a === void 0 ? void 0 : _a.logo) ? [(_b = restaurant.media) === null || _b === void 0 ? void 0 : _b.logo] : [],
        name: extractLocalizedString(restaurant.title, restaurant.locale),
        openingHoursSpecification: undefined,
        priceRange: '',
        telephone: restaurant.contact.phone,
        url: baseUrl,
        menu: menuUrl,
    };
}
function getSeoMenu(restaurant, displayableMenu) {
    return {
        '@type': 'Menu',
        name: extractLocalizedString(restaurant.title, restaurant.locale),
        description: extractLocalizedString(restaurant.description, restaurant.locale),
        hasMenuSection: displayableMenu.map(function (displayableSubMenu) {
            return getSeoSubMenu(displayableSubMenu);
        }),
    };
}
function getSeoSubMenu(displayableSubMenu) {
    return {
        '@type': 'MenuSection',
        name: displayableSubMenu.displayableTitle || '',
        description: displayableSubMenu.displayableDescription || '',
        image: '',
        hasMenuSection: displayableSubMenu.sections.map(getSeoMenuSection),
        hasMenuItem: [],
    };
}
function getSeoMenuSection(displayableSection) {
    return {
        '@type': 'MenuSection',
        name: displayableSection.displayableTitle || '',
        description: displayableSection.displayableDescription || '',
        image: displayableSection.image || '',
        hasMenuSection: [],
        hasMenuItem: displayableSection.items.map(getSeoMenuItem),
    };
}
function getSeoMenuItem(displayableMenuItem) {
    return {
        '@type': 'MenuItem',
        name: displayableMenuItem.displayableTitle || '',
        description: displayableMenuItem.displayableDescription || '',
        image: displayableMenuItem.image || '',
        offers: [
            {
                '@type': 'Offer',
                price: displayableMenuItem.displayablePrice,
                priceCurrency: displayableMenuItem.currency,
            },
        ],
    };
}
//# sourceMappingURL=seoLogic.js.map